module.exports = __webpack_public_path__ + "static/media/logo.d815fa71.png";